module.exports = require("./hy.d.ts");